import React from "react";

const Stat_Z_Table = () => {
  return (
    <div>
      <h1>Stat Z-Table</h1>
    </div>
  );
};

export default Stat_Z_Table;
